import "./assets/CTAButton.css";
const t = "_button_8899m_3", n = "_secondary_8899m_42", o = "_inverted_8899m_106", s = {
  button: t,
  secondary: n,
  inverted: o
};
export {
  s
};
